import { gql } from '@apollo/client'

export default gql(`
    query listProduction($search: SearchInput $limit: Int $offset: Int $project: String){
        listProductionStudio( 
            search: $search
            limit: $limit
            offset: $offset
            project: $project
        ) {
        items {
            id
            name
            source
            assetCount
        }
        totalCount
    }
}`)
